exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-all-pages-js": () => import("./../../../src/pages/All pages.js" /* webpackChunkName: "component---src-pages-all-pages-js" */),
  "component---src-pages-categories-js": () => import("./../../../src/pages/Categories.js" /* webpackChunkName: "component---src-pages-categories-js" */),
  "component---src-templates-category-js": () => import("./../../../src/templates/category.js" /* webpackChunkName: "component---src-templates-category-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

